"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styles_1 = require("@mui/material/styles");
const colors = tslib_1.__importStar(require("../colors"));
const createPalette_1 = tslib_1.__importStar(require("./createPalette"));
const { charcoal, turquoise } = colors;
function createNfcertTheme(options, ...localeObjects) {
    const palette = (0, createPalette_1.default)({
        primary: {
            contrastText: (0, createPalette_1.getContrastText)(charcoal[500], 3),
            dark: charcoal[700],
            light: charcoal[300],
            main: charcoal[500],
        },
        secondary: {
            contrastText: (0, createPalette_1.getContrastText)(turquoise[500], 3),
            dark: turquoise[700],
            light: turquoise[300],
            main: turquoise[500],
        },
        mode: "light",
        ...options?.palette,
    });
    const theme = (0, styles_1.createTheme)({
        ...options,
        palette,
        components: Object.assign({
            ...options?.components,
            MuiCheckbox: {
                ...options?.components?.MuiCheckbox,
                defaultProps: {
                    color: "secondary",
                },
            },
            MuiRadio: {
                ...options?.components?.MuiRadio,
                defaultProps: {
                    color: "secondary",
                },
            },
            MuiSwitch: {
                ...options?.components?.MuiSwitch,
                defaultProps: {
                    color: "secondary",
                },
            },
            MuiTooltip: {
                ...options?.components?.MuiTooltip,
                styleOverrides: {
                    tooltip: ({ theme }) => ({
                        fontSize: 14,
                        padding: theme.spacing(1, 2),
                    }),
                },
            },
        }),
    }, ...localeObjects);
    /**
     * Non enumerable property defined so that we are able to identify the theme by name
     * after the theme object is created.
     */
    Object.defineProperty(theme, "__MNEMONIC_THEME__", { value: "nfcert", enumerable: false });
    return theme;
}
exports.default = createNfcertTheme;
